import { FC } from 'react';
import { sidebarControllerFactory } from 'src/v2/features/sidebarController';

export const entitySidebarControllerFactory = (
  sidebarName: string,
  routes: { path: string; render: FC<any> }[],
): ReturnType<typeof sidebarControllerFactory> => sidebarControllerFactory(sidebarName, routes);
